import {
    MealPaymentType,
    MethodOfCalcTheFee,
    SettlementStaysFormFields,
    UpdateSettlementStaysDTO,
} from 'types';
import { parseDayjsTimeIntoHoursMinutesFormat } from '../dateTime/parseDayjsTimeIntoHoursMinutesFormat';

export const parseSettlementStaysFormFieldsIntoUpdateSettlementStaysDTO = (
    settlementStaysFormFields: SettlementStaysFormFields,
): UpdateSettlementStaysDTO => {
    const { freePeriodStart, freePeriodEnd, settlementType, paymentType, ...otherFields } =
        settlementStaysFormFields;

    return {
        ...otherFields,
        settlementType: settlementType as MealPaymentType,
        paymentType: paymentType as MethodOfCalcTheFee,
        freePeriodStart: freePeriodStart
            ? parseDayjsTimeIntoHoursMinutesFormat(freePeriodStart)
            : null,
        freePeriodEnd: freePeriodEnd ? parseDayjsTimeIntoHoursMinutesFormat(freePeriodEnd) : null,
    };
};
